import { createApp } from 'vue'
import selene from './selene'
import App from './App.vue'

const app = createApp(App)
app.use(selene)
app.mount('#app')
